// source: netop_rc_mouse.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.netop.rc.mouse.MouseCursor', null, global);
goog.exportSymbol('proto.netop.rc.mouse.MouseMessage', null, global);
goog.exportSymbol('proto.netop.rc.mouse.MouseMessageType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.mouse.MouseMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.mouse.MouseMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.mouse.MouseMessage.displayName = 'proto.netop.rc.mouse.MouseMessage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.netop.rc.mouse.MouseCursor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.netop.rc.mouse.MouseCursor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.netop.rc.mouse.MouseCursor.displayName = 'proto.netop.rc.mouse.MouseCursor';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.mouse.MouseMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.mouse.MouseMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.mouse.MouseMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.mouse.MouseMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    messageType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.mouse.MouseMessage}
 */
proto.netop.rc.mouse.MouseMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.mouse.MouseMessage;
  return proto.netop.rc.mouse.MouseMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.mouse.MouseMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.mouse.MouseMessage}
 */
proto.netop.rc.mouse.MouseMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.netop.rc.mouse.MouseMessageType} */ (reader.readEnum());
      msg.setMessageType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.mouse.MouseMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.mouse.MouseMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.mouse.MouseMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.mouse.MouseMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessageType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional MouseMessageType message_type = 1;
 * @return {!proto.netop.rc.mouse.MouseMessageType}
 */
proto.netop.rc.mouse.MouseMessage.prototype.getMessageType = function() {
  return /** @type {!proto.netop.rc.mouse.MouseMessageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.netop.rc.mouse.MouseMessageType} value
 * @return {!proto.netop.rc.mouse.MouseMessage} returns this
 */
proto.netop.rc.mouse.MouseMessage.prototype.setMessageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.netop.rc.mouse.MouseCursor.prototype.toObject = function(opt_includeInstance) {
  return proto.netop.rc.mouse.MouseCursor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.netop.rc.mouse.MouseCursor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.mouse.MouseCursor.toObject = function(includeInstance, msg) {
  var f, obj = {
    messageType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    hotspotx: jspb.Message.getFieldWithDefault(msg, 2, 0),
    hotspoty: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cursorimage: msg.getCursorimage_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.netop.rc.mouse.MouseCursor}
 */
proto.netop.rc.mouse.MouseCursor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.netop.rc.mouse.MouseCursor;
  return proto.netop.rc.mouse.MouseCursor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.netop.rc.mouse.MouseCursor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.netop.rc.mouse.MouseCursor}
 */
proto.netop.rc.mouse.MouseCursor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.netop.rc.mouse.MouseMessageType} */ (reader.readEnum());
      msg.setMessageType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHotspotx(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHotspoty(value);
      break;
    case 4:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setCursorimage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.netop.rc.mouse.MouseCursor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.netop.rc.mouse.MouseCursor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.netop.rc.mouse.MouseCursor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.netop.rc.mouse.MouseCursor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessageType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getHotspotx();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getHotspoty();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getCursorimage_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      4,
      f
    );
  }
};


/**
 * optional MouseMessageType message_type = 1;
 * @return {!proto.netop.rc.mouse.MouseMessageType}
 */
proto.netop.rc.mouse.MouseCursor.prototype.getMessageType = function() {
  return /** @type {!proto.netop.rc.mouse.MouseMessageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.netop.rc.mouse.MouseMessageType} value
 * @return {!proto.netop.rc.mouse.MouseCursor} returns this
 */
proto.netop.rc.mouse.MouseCursor.prototype.setMessageType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 hotspotX = 2;
 * @return {number}
 */
proto.netop.rc.mouse.MouseCursor.prototype.getHotspotx = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.mouse.MouseCursor} returns this
 */
proto.netop.rc.mouse.MouseCursor.prototype.setHotspotx = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 hotspotY = 3;
 * @return {number}
 */
proto.netop.rc.mouse.MouseCursor.prototype.getHotspoty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.netop.rc.mouse.MouseCursor} returns this
 */
proto.netop.rc.mouse.MouseCursor.prototype.setHotspoty = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bytes cursorImage = 4;
 * @return {!(string|Uint8Array)}
 */
proto.netop.rc.mouse.MouseCursor.prototype.getCursorimage = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * optional bytes cursorImage = 4;
 * This is a type-conversion wrapper around `getCursorimage()`
 * @return {string}
 */
proto.netop.rc.mouse.MouseCursor.prototype.getCursorimage_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getCursorimage()));
};


/**
 * optional bytes cursorImage = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getCursorimage()`
 * @return {!Uint8Array}
 */
proto.netop.rc.mouse.MouseCursor.prototype.getCursorimage_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getCursorimage()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.netop.rc.mouse.MouseCursor} returns this
 */
proto.netop.rc.mouse.MouseCursor.prototype.setCursorimage = function(value) {
  return jspb.Message.setProto3BytesField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.netop.rc.mouse.MouseMessageType = {
  UNDEFINED: 0,
  CURSOR: 1
};

goog.object.extend(exports, proto.netop.rc.mouse);
